"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DecoratedWorkspaceSettingsService = void 0;
var tslib_1 = require("tslib");
/**
 * @alpha
 */
var DecoratedWorkspaceSettingsService = /** @class */ (function () {
    function DecoratedWorkspaceSettingsService(decorated) {
        this.decorated = decorated;
    }
    DecoratedWorkspaceSettingsService.prototype.getSettings = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.decorated.getSettings()];
            });
        });
    };
    DecoratedWorkspaceSettingsService.prototype.getSettingsForCurrentUser = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.decorated.getSettingsForCurrentUser()];
            });
        });
    };
    return DecoratedWorkspaceSettingsService;
}());
exports.DecoratedWorkspaceSettingsService = DecoratedWorkspaceSettingsService;
//# sourceMappingURL=workspaceSettings.js.map